import React, { useEffect } from "react";
import Quote from "./components/quote";
// import Test from './components/test';

function App() {
  useEffect(() => {
    document.title = "Quoting Tool";
  }, []);
  return (
    <div>
      <Quote />
      {/* <Test /> */}
      {/* Other components or content can go here */}
    </div>
  );
}

export default App;
